import * as React from "react";
import {Admin as RAAdmin, Resource} from 'react-admin';
import {Provider, useSelector} from 'react-redux'
import polyglotI18nProvider from 'ra-i18n-polyglot';
import {createHashHistory} from 'history'

import englishMessages from './i18n/en';
import portugueseMessages from './i18n/pt';
import routes from "./routes";
import dataProvider from "./providers/dataProvider";
import authProvider from "./providers/authProvider";
import LoginPage from "./layout/Login";
import Layout from "./layout/Layout";
import RecipeEdit from "./components/recipe/RecipeEdit";
import RecipeList from "./components/recipe/RecipeList";
import RecipeCreate from "./components/recipe/RecipeCreate";
import RestaurantProductList from "./components/restaurantProducts/RestaurantProductList";
import RestaurantProductEdit from "./components/restaurantProducts/RestaurantProductEdit";
import RestaurantProductCreate from "./components/restaurantProducts/RestaurantProductCreate";
import RestaurantMenuList from "./components/restaurantMenus/RestaurantMenuList";
import RestaurantMenuEdit from "./components/restaurantMenus/RestaurantMenuEdit";
import RestaurantMenuCreate from "./components/restaurantMenus/RestaurantMenuCreate";
import ReservationList from "./components/reservations/ReservationList";
import ReservationEdit from "./components/reservations/ReservationEdit";
import ReservationCreate from "./components/reservations/ReservationCreate";
import TakeAwayRequestList from "./components/takeAwayRequests/TakeAwayRequestList";
import TakeAwayRequestEdit from "./components/takeAwayRequests/TakeAwayRequestEdit";
import TakeAwayRequestCreate from "./components/takeAwayRequests/TakeAwayRequestCreate";
import Dashboard from "./components/dashboard/Dashboard";
import ContactCreate from "./components/support/ContactCreate";
import customReducers from "./redux/reducers";
import createAdminStore from "./redux/createAdminStore";
import UserProfileEdit from "./components/user/UserProfileEdit";


const i18nProvider = (initialLocale) => polyglotI18nProvider(locale => {
    if (locale === 'pt') {
        return portugueseMessages;
    }
    return englishMessages;
}, initialLocale || 'en');

const history = createHashHistory()

const App = () => {
    return (
        <Provider
            store={createAdminStore({
                authProvider,
                dataProvider,
                history,
                customReducers: {
                    theme: customReducers.themeReducer,
                    locale: customReducers.localeReducer
                },
            })}
        >
            <Admin/>
        </Provider>
    )
};

const Admin = () => {
    const locale = useSelector(state => state.locale)
    return (
        <RAAdmin
            i18nProvider={i18nProvider(locale)}
            dashboard={Dashboard}
            authProvider={authProvider}
            dataProvider={dataProvider}
            loginPage={LoginPage}
            layout={Layout}
            // theme={myTheme}
            customRoutes={routes}
            history={history}
            disableTelemetry //In production, react-admin applications send an anonymous request on mount to a telemetry server operated by marmelab.
        >

            {/* <Resource name="categories" list={ListGuesser} /> */}
            <Resource name="categories" />
            <Resource name="restaurants"/>
            <Resource name="products"/>
            <Resource name="users" edit={UserProfileEdit}/>
            <Resource name="units"/>
            <Resource name="charities"/>
            <Resource name="contacts" create={ContactCreate}/>
            <Resource name="recipes" list={RecipeList} edit={RecipeEdit} create={RecipeCreate}/>
            <Resource name="restaurant-products" list={RestaurantProductList} edit={RestaurantProductEdit}
                      create={RestaurantProductCreate}/>
            <Resource name="restaurant-menus" list={RestaurantMenuList} edit={RestaurantMenuEdit}
                      create={RestaurantMenuCreate}/>
            <Resource name="take-away-requests" list={TakeAwayRequestList} edit={TakeAwayRequestEdit}
                      create={TakeAwayRequestCreate}/>
            {/* <Resource name="reservations" list={ListGuesser} /> */}
            <Resource name="reservations" list={ReservationList} edit={ReservationEdit} create={ReservationCreate}/>
        </RAAdmin>
    );
};

export default App;
